import { loadView } from '@/helper/utils'
import { mainLayout } from '@/components/layouts/Main'

export default {
  path: '/line_top',
  component: mainLayout(loadView('lineTop/LineTop')),
  children: [
    {
      path: 'error',
      name: 'LineTopError',
      component: loadView('lineTop/LineTopError'),
      meta: { requiresAuth: true }
    },
    {
      path: 'complete',
      name: 'LineTopComplete',
      component: loadView('lineTop/LineTopComplete'),
      meta: { requiresAuth: true }
    },
    {
      path: 'cancel',
      name: 'LineTopCancel',
      component: loadView('lineTop/LineTopCancel'),
      meta: { requiresAuth: true }
    }
  ]
}
